"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var Icon_1 = require("../../icons/Icon");

var flexStyles = require("@headspace/hs-web-style-guide/dist/flex");

var _a = flexStyles.default,
    flex = _a.flex,
    justifyContentCenter = _a.justifyContentCenter,
    alignItemsCenter = _a.alignItemsCenter;

var buttonSizeStyle = function buttonSizeStyle(buttonSize) {
  return hs_web_style_guide_1.css({
    width: buttonSize,
    height: buttonSize
  });
};

var buttonStyle = hs_web_style_guide_1.css({
  borderRadius: '50%',
  backgroundColor: colors_1.merino,
  border: 'none',
  ':hover': {
    backgroundColor: colors_1.springWood
  },
  ':disabled svg': {
    opacity: 0.4
  }
});

function IconButton(props) {
  var src = props.src,
      sm = props.sm,
      ariaLabel = props.ariaLabel,
      fill = props.fill,
      otherProps = __rest(props, ["src", "sm", "ariaLabel", "fill"]);

  var buttonSize = sm ? 32 : 48;
  var iconSize = sm ? 16 : 24;
  return React.createElement("button", __assign({
    className: "iconButton",
    type: "text"
  }, buttonSizeStyle(buttonSize), buttonStyle, flex, justifyContentCenter, alignItemsCenter, otherProps), React.createElement(Icon_1.Icon, {
    src: src,
    width: iconSize,
    height: iconSize,
    fill: fill,
    ariaLabel: ariaLabel
  }));
}

exports.IconButton = IconButton;